// extracted by mini-css-extract-plugin
module.exports = {"regionContainer":"RegionSlug_regionContainer__J2YmE","title":"RegionSlug_title__k2NmP","pageIntroduction":"RegionSlug_pageIntroduction__Ft3u_"};